<template>
  <a-modal
      :title="title"
      :visible="visible"
      :maskClosable="false"
      :width="960"
      destroyOnClose
      @ok="onSave"
      @cancel="$emit('cancel')"
      :confirmLoading="loading">
    <a-form-model :model="form" ref="form" :rules="rules" class="custom pick-100 form-input">
          <a-form-model-item label="理由" prop="reason">
            <a-textarea
                placeholder="请填写理由"
                :atow-size="{minSize:3,maxSize:5}"
                v-model="form.reason"/>
          </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
const rules = {
  reason: [{ required: true, message: '原因不能为空！', trigger: 'change' }],
}
export default {
  name: 'NotAttendReason',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '标题'
    }
  },
  data () {
    return {
      rules: rules,
      form: {
        reason : ''
      },
      loading: false,
    }
  },
  methods: {
    //初始化数据
    initData (data) {
      this.form = {...data}
    },
    //回传输入的值
    onSave () {
      let that = this
      this.$refs.form.validate( valid => {
        if (!valid) {
          return
        }
        that.$emit('success', this.form)
      })

    }
  }
}
</script>

<style scoped>

</style>
